import { render, staticRenderFns } from "./dialogMain.vue?vue&type=template&id=79e3ead2&scoped=true&"
import script from "./dialogMain.vue?vue&type=script&lang=js&"
export * from "./dialogMain.vue?vue&type=script&lang=js&"
import style0 from "./dialogMain.vue?vue&type=style&index=0&id=79e3ead2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e3ead2",
  null
  
)

export default component.exports